export default {
  colorPrimary: {
    backgroundColor: 'rgba(255,255,255,0.8)'
  }
};
